import { STUDIO_THEMES, type StudioTheme } from 'fym-shared/src/music24/studioThemes';
import { trackEvent } from '../../analytics/sml/analytics';

/** An old row can name a theme that is gone. */
const THEMES: Readonly<Record<string, StudioTheme | undefined>> = STUDIO_THEMES;

type DownloadSurface = 'viewer' | 'kit' | 'zip' | 'manual';

/** `asset_downloaded`. With no asset type (a zip, a file of a post) the event names only the place. */
export function trackAssetDownloaded(themeId: string | undefined, surface: DownloadSurface): void {
  const theme = themeId === undefined ? undefined : THEMES[themeId];
  trackEvent('asset_downloaded', {
    ...(themeId === undefined ? {} : { assetType: themeId }),
    ...(theme === undefined ? {} : { format: theme.format }),
    surface,
  });
}
